module.exports = __webpack_public_path__ + "media/images/logos/today_show-0ec5c05f3cb51831bfcfde91988bb9c0.svg";